import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  ASSISTANT_PLANS,
  CLUSTER_TYPES,
  INSTANCE_CATEGORY,
  PLAN_LIST,
} from '../../../constants';
import { isGPSInstance } from '../../../utils/utils';

const styles = {
  LEGACY: {
    color: 'white',
    backgroundColor: '#BDBDBD',
    fontWeight: 'bold',
  },
  COMMUNITY: {
    color: 'white',
    backgroundColor: '#505050',
    fontWeight: 'bold',
  },
  STANDARD: {
    color: 'white',
    backgroundColor: '#0c63a6',
    fontWeight: 'bold',
  },
  ENTERPRISE: {
    color: 'white',
    backgroundColor: '#fdc60e',
    fontWeight: 'bold',
  },
  CPU: {
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: '#0c63a6',
  },
  GPU: {
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: '#fdc60e',
  },
};

const selectedSolrPlan = (category, plan) => {
  switch (category) {
    case INSTANCE_CATEGORY.COMMUNITY:
      return INSTANCE_CATEGORY.COMMUNITY;
    case INSTANCE_CATEGORY.STANDARD:
      return PLAN_LIST.slice(1)
        .find((pl) => {
          return pl.type === plan;
        })
        .name.toUpperCase();
    case INSTANCE_CATEGORY.ENTERPRISE:
      return INSTANCE_CATEGORY.ENTERPRISE;
    default:
      return INSTANCE_CATEGORY.LEGACY;
  }
};

const SecondaryChip = ({ instance, ...restProps }) => {
  if (!instance.clusterType || isGPSInstance(instance.clusterType)) return null;

  const { t } = useTranslation();

  const instanceTypes = {
    [CLUSTER_TYPES.SOLR_CLUSTER]: {
      label: t('plan', {
        ns: 'instance',
        type: selectedSolrPlan(instance.category, instance.instances[0].type),
      }),
      style: styles[instance.category],
    },
    [CLUSTER_TYPES.MODEL_CLUSTER]: {
      label: t('modelPlan', { ns: 'model', plan: instance.category }),
      style: styles[instance.category],
    },
    [CLUSTER_TYPES.CUSTOM_CLUSTER]: {
      label: instance.designation,
      style: {
        color: 'white',
        fontWeight: 600,
        bgcolor: '#0c63a6',
      },
    },
    [CLUSTER_TYPES.ASSISTANT_CLUSTER]: {
      label: t('plan', {
        ns: 'instance',
        type: ASSISTANT_PLANS[instance.instances[0].type],
      }),
      style: {
        fontWeight: 600,
        color: 'white',
        bgcolor:
          ASSISTANT_PLANS[instance.instances[0].type] === ASSISTANT_PLANS.PRO
            ? '#fdc60e'
            : '#0c63a6',
      },
    },
  };

  return (
    <Chip
      size="small"
      label={instanceTypes[instance.clusterType].label}
      sx={instanceTypes[instance.clusterType].style}
      {...restProps}
    />
  );
};

SecondaryChip.propTypes = {
  instance: PropTypes.object.isRequired,
};

export default SecondaryChip;
